export default __webpack_public_path__ + "static/media/logo-meeting.2607cb90.png";